module.exports = __webpack_public_path__ + "img/能源系统集成.e51fd8ed.png";